import React from 'react';

import { IonCol, IonGrid, IonRow } from '@ionic/react';

import { Accordion, AccordionGroup } from 'components/Accordion';
import { DescriptionItem } from 'components/DescriptionList';

import './index.css';

const ListSkeleton = () => {
  return (
    <div className={'fr-skeleton'}>
      <AccordionGroup>
        <Accordion>
          <IonGrid>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Period'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Status'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Due date'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Affiliates'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Customer Company'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Applications'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Expense Type'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Currency'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Importance'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Spend'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Original Spend'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Approvers'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Last Updated By'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Created By'} type={'skeleton'} />
              </IonCol>
            </IonRow>
          </IonGrid>
        </Accordion>
        <Accordion title={'Summary by Applications'} />
      </AccordionGroup>
    </div>
  );
};
export default ListSkeleton;
